module.exports = __webpack_public_path__ + "static/img/img-fraud.3077c64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-fraud.png
// module id = ndxm
// module chunks = 36